function initParallax() {
    jarallax(document.querySelectorAll('.has-parallax-feed .gh-card'), {
        speed: 0.8,
    });
}



function pagination(isInfinite = true, done) {
    let loading = false;
    const feedElement = document.querySelector('.gh-feed');
    const target = feedElement.nextElementSibling || feedElement.parentElement.nextElementSibling;

    const loadNextPage = async function () {
        const nextElement = document.querySelector('link[rel=next]');

        if (!nextElement) {
            return;
        }

        try {
            const res = await fetch(nextElement.href);
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const posts = doc.querySelectorAll('.gh-feed > *');

            posts.forEach(function (post) {
                feedElement.appendChild(document.importNode(post, true));
            });

            if (done) {
                done();
            }

            const resNextElement = doc.querySelector('link[rel=next]');
            if (resNextElement && resNextElement.href) {
                nextElement.href = resNextElement.href;
            } else {
                nextElement.remove();
            }
        } catch (e) {
            nextElement.remove();
            throw e;
        }
    };

    const callback = async function (entries) {
        if (loading) {
            return;
        }

        loading = true;

        if (entries[0].isIntersecting) {
            // keep loading next page until target is out of the viewport or we've loaded the last page
            while (target.getBoundingClientRect().top <= window.innerHeight && document.querySelector('link[rel=next]')) {
                await loadNextPage();
            }
        }

        loading = false;

        if (!document.querySelector('link[rel=next]')) {
            observer.disconnect();
        }
    };

    const observer = new IntersectionObserver(callback);
    observer.observe(target);
}

(function () {
    initParallax();
})();

(function () {
    const toggle = document.querySelector('[data-toggle-comments]');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
        document.body.classList.toggle('comments-opened');
    });
})();

(function () {
    const element = document.querySelector('.gh-article-excerpt');
    if (!element) return;

    let text = element.textContent;
    const emojiRE = /\p{EPres}|\p{ExtPict}/gu;

    const emojis = text.match(emojiRE);
    if (!emojis) return;

    emojis.forEach(function (emoji) {
        text = text.replace(emoji, `<span class="emoji">${emoji}</span>`);
    });

    element.innerHTML = text;
})();

(function () {
    pagination(true, initParallax);
})();


window.addEventListener('load', function () {
    var elems = document.getElementsByClassName('whatido');
    if(elems.length == 0) return;
    var WhatIDo = ["Liedjesmaker", "Cabaretier", "Schrijver", "Theatermaker", "Pianist", "Rolmodel", "Knutselaar", "Protagonist", "Icoon"];
    function nextGlitch() {
        var elems = document.getElementsByClassName('whatido');
        var possible = WhatIDo.map(function (a) { return a });
        for (const elem of elems) {
            var index = possible.indexOf(elem.innerHTML.trim());
            if (index != -1) {
                possible.splice(index, 1);
            }
        }
        var r = Math.floor(Math.random() * 3);
        possible = possible.shuffle();
        glitchElem(elems[r], possible[0]);
        setTimeout(nextGlitch, Math.random() * 4000 + 600);
    }
    function glitchElem(element, newText) {
        element.classList.add("glitch");

        setTimeout((function () {
            this.el.innerHTML = newText;

            this.el.classList.remove("glitch");
            this.el.classList.add("unglitch");

        }).bind({ el: element, t: newText }), 100);
        setTimeout((function () {
            this.el.classList.remove("unglitch");

        }).bind({ el: element, t: newText }), 200);
    }

    setTimeout(nextGlitch, Math.random() * 1000 + 2000);
});

Array.prototype.shuffle = function () {
    var i = this.length, j, temp;
    if (i == 0) return this;
    while (--i) {
        j = Math.floor(Math.random() * (i + 1));
        temp = this[i];
        this[i] = this[j];
        this[j] = temp;
    }
    return this;
};